import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { clsx } from 'clsx';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-heading font-bold uppercase tracking-wider transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-900 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-brand-orange hover:bg-orange-600 text-white shadow-lg shadow-orange-900/20 focus:ring-brand-orange',
    secondary: 'bg-slate-700 hover:bg-slate-600 text-white focus:ring-slate-500',
    outline: 'border-2 border-slate-600 hover:border-brand-orange text-slate-300 hover:text-brand-orange bg-transparent focus:ring-slate-500'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2 rounded-sm',
    md: 'text-base px-6 py-3 rounded-sm',
    lg: 'text-lg px-8 py-4 rounded-md',
    xl: 'text-xl px-10 py-5 rounded-md'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={clsx(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} {...props} data-id="element-299">
      {children}
    </motion.button>;
}